import * as React from 'react'
import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider'
import getMuiTheme from 'material-ui/styles/getMuiTheme'
import {Navigation} from './Navigation'
import {Login} from '../Pages/Login/LoginView'
import {LoginFormAction} from '../Components/LoginForm/LoginFormActions'
import {OrderOverview} from '../Pages/OrderOverview/OrderOverviewView'
import {OrderDetailsView} from '../Pages/OrderDetails/OrderDetailsView'
import {PasswordLost} from '../Pages/PasswordLost/PasswordLostView'
import {PasswordLostAction} from '../Pages/PasswordLost/PasswordLostActions'
import {PasswordChangeAction} from '../Pages/PasswordChange/PasswordChangeActions'
import {PasswordChange} from '../Pages/PasswordChange/PasswordChangeView'
import {OrderOverviewAction} from '../Pages/OrderOverview/OrderOverviewActions'
import {ChooseManufacturer} from '../Pages/ChooseManufacturer/ChooseManufacturerView'
import {ChooseManufacturerAction} from '../Pages/ChooseManufacturer/ChooseManufacturerActions'
import {OrderDetailsAction} from '../Pages/OrderDetails/OrderDetailsActions'
import {OrderCreateView} from '../Pages/OrderCreate/OrderCreateView'
import {OrderCreateAction} from '../Pages/OrderCreate/OrderCreateActions'
import {Action} from './Actions'
import {ReloginView} from '../Pages/Relogin/ReloginView'
import creiosTheme from '../Theme/creiosTheme'
import {InquiryOverviewView} from '../Pages/InquiryOverview/InquiryOverviewView'
import {InquiryOverviewAction} from '../Pages/InquiryOverview/InquiryOverviewActions'
import {InquiryDetailsView} from '../Pages/InquiryDetails/InquiryDetailsView'
import {InquiryDetailsAction} from '../Pages/InquiryDetails/InquiryDetailsActions'
import {OrderExportCreateView} from '../Pages/OrderExportCreate/OrderExportCreateView'
import {OrderExportCreateAction} from '../Pages/OrderExportCreate/OrderExportCreateActions'
import {connect} from 'react-redux'
import {AuthenticatedPage, State} from './State'
import {ProductCalculationOverviewView} from '../Pages/ProductCalculationOverview/ProductCalculationOverviewView'
import {ProductCalculationOverviewAction} from '../Pages/ProductCalculationOverview/ProductCalculationOverviewActions'
import {ProductCalculationDetailsView} from '../Pages/ProductCalculationDetails/ProductCalculationDetailsView'
import {ProductCalculationDetailsAction} from '../Pages/ProductCalculationDetails/ProductCalculationDetailsActions'
import {OrderExportOverviewView} from '../Pages/OrderExportOverview/OrderExportOverviewView'
import {OrderExportOverviewAction} from '../Pages/OrderExportOverview/OrderExportOverviewActions'
import {ProductCalculationImportView} from '../Pages/ProductCalculationImport/ProductCalculationImportView'
import {ProductCalculationImportAction} from '../Pages/ProductCalculationImport/ProductCalculationImportActions'
import MuiThemeProviderNext from 'material-ui-next/styles/MuiThemeProvider'
import {theme} from '../Style'
import {PrismaRequestOverviewView} from '../Pages/PrismaRequestOverview/PrismaRequestOverviewView'
import {PrismaRequestOverviewAction} from '../Pages/PrismaRequestOverview/PrismaRequestOverviewActions'
import {PrismaRequestDetailsView} from '../Pages/PrismaRequestDetails/PrismaRequestDetailsView'
import {PrismaRequestDetailsAction} from '../Pages/PrismaRequestDetails/PrismaRequestDetailsActions'
import {FullScreenLoader} from '../View/FullScreenLoader'
import LinearProgress from 'material-ui/LinearProgress'
import Snackbar from 'material-ui-next/Snackbar'
import {httpErrorToMessage} from '../Data/Http'
import Button from 'material-ui-next/Button'
import injectSheet from 'react-jss'

const muiTheme = getMuiTheme(creiosTheme)

const styles = {
    app: {
        height: '100%',
    },
    content: {
        height: '100%'
    }
}

interface Properties {
    readonly state: State
    readonly dispatch: (action: Action) => void
}

export const AppContainer =
    connect(
        (state: State) => ({state}),
        (dispatch: (action: Action) => void) => ({dispatch})
    )(
        injectSheet<Properties>(styles)(
            ({classes, state, dispatch}) => {
                const content =
                    (() => {
                        switch (state.type) {
                            case 'Public':
                                return (() => {
                                    const {page} = state
                                    switch (page.type) {
                                        case 'LoginPage':
                                            return (
                                                <Login
                                                    state={page.state}
                                                    dispatch={
                                                        (subAction: LoginFormAction) =>
                                                            dispatch({
                                                                type: 'LoginPageAction',
                                                                subAction,
                                                            })}
                                                />)
                                        case 'PasswordLostPage':
                                            return (
                                                <PasswordLost
                                                    state={page.state}
                                                    dispatch={
                                                        (subAction: PasswordLostAction) =>
                                                            dispatch({
                                                                type: 'PasswordLostPageAction',
                                                                subAction,
                                                            })}
                                                />)
                                        case 'PublicRedirectPage':
                                            return 'Redirecting...'
                                    }
                                })()
                            case 'ChoosingManufacturer': {
                                return (() => {
                                    const {page} = state
                                    switch (page.type) {
                                        case 'ChooseManufacturerPage':
                                            return (
                                                <ChooseManufacturer
                                                    intermediateSession={state.intermediateSession}
                                                    state={page.state}
                                                    dispatch={
                                                        (subAction: ChooseManufacturerAction) =>
                                                            dispatch({
                                                                type: 'ChooseManufacturerPageAction',
                                                                subAction,
                                                            })}
                                                />
                                            )
                                        case 'ChoosingManufacturerRedirectPage':
                                            return 'Redirecting...'
                                    }
                                })()
                            }
                            case 'Authenticated': {
                                const page = state.page
                                return (
                                    <div className={classes.content}>
                                        {state.relogin !== null &&
                                        <ReloginView
                                            state={state.relogin.modal}
                                            dispatch={
                                                (subAction: LoginFormAction) =>
                                                    dispatch({
                                                        type: 'ReloginModalAction',
                                                        subAction,
                                                    })}
                                        />}
                                        {state.loadingIndicator &&
                                        <LinearProgress
                                            mode="indeterminate"
                                            style={{
                                                position: 'absolute',
                                                display: 'fixed',
                                                top: 0,
                                                left: 0,
                                                width: '100%',
                                                zIndex: 1000000
                                            }}
                                        />
                                        }
                                        <AuthenticatedPageView
                                            page={page}
                                            dispatch={dispatch}
                                        />
                                        <Snackbar
                                            message={
                                                <span
                                                    title={
                                                        state.pageLoad.type === 'Failure'
                                                            ? httpErrorToMessage(state.pageLoad.error)
                                                            : ''
                                                    }
                                                >
                                                    Netzwerkfehler
                                                </span>
                                            }
                                            action={
                                                <Button
                                                    color="default"
                                                    onClick={
                                                        () =>
                                                            dispatch({type: 'RetryPageLoad'})
                                                    }
                                                >
                                                    Erneut versuchen
                                                </Button>
                                            }
                                            open={state.pageLoad.type === 'Failure'}
                                        />
                                    </div>)
                            }
                        }
                    })()
                return (
                    <MuiThemeProviderNext theme={theme}>
                        <MuiThemeProvider muiTheme={muiTheme}>
                            <div className={classes.app}>
                                <Navigation
                                    open={state.type === 'Authenticated' && state.drawerOpen}
                                    dispatch={dispatch}
                                    cis2User={
                                        (() => {
                                            switch (state.type) {
                                                case 'Public':
                                                    return null
                                                case 'ChoosingManufacturer':
                                                    return state.intermediateSession.cis2User
                                                case 'Authenticated':
                                                    return state.session.cis2User
                                            }
                                        })()
                                    }
                                    disabled={state.type === 'Public'}
                                    manufacturer={
                                        state.type === 'Authenticated'
                                            ? state.session.manufacturer
                                            : null
                                    }
                                />
                                {content}
                            </div>
                        </MuiThemeProvider>
                    </MuiThemeProviderNext>
                )
            }
        )
    )

function AuthenticatedPageView({page, dispatch}: {
    page: AuthenticatedPage,
    dispatch: (action: Action) => void,
}): JSX.Element {
    switch (page.type) {
        case 'AuthenticatedLoadingPage':
            return <FullScreenLoader/>
        case 'OrderOverviewPage':
            return (
                <OrderOverview
                    state={page.state}
                    dispatch={
                        (subAction: OrderOverviewAction) =>
                            dispatch({
                                type: 'OrderOverviewPageAction',
                                subAction
                            })}
                />)
        case 'OrderDetailsPage':
            return (
                <OrderDetailsView
                    state={page.state}
                    dispatch={
                        (subAction: OrderDetailsAction) =>
                            dispatch({
                                type: 'OrderDetailsPageAction',
                                subAction
                            })}
                />)
        case 'OrderCreatePage':
            return (
                <OrderCreateView
                    state={page.state}
                    dispatch={(subAction: OrderCreateAction) =>
                        dispatch({
                            type: 'OrderCreatePageAction',
                            subAction,
                        })}
                />)
        case 'OrderExportCreatePage':
            return (
                <OrderExportCreateView
                    state={page.state}
                    dispatch={
                        (subAction: OrderExportCreateAction) =>
                            dispatch({
                                type: 'OrderExportCreatePageAction',
                                subAction
                            })
                    }
                />
            )
        case 'OrderExportOverviewPage':
            return (
                <OrderExportOverviewView
                    state={page.state}
                    dispatch={
                        (subAction: OrderExportOverviewAction) =>
                            dispatch({
                                type: 'OrderExportOverviewPageAction',
                                subAction,
                            })
                    }
                />
            )
        case 'PasswordChangePage':
            return (
                <PasswordChange
                    state={page.state}
                    dispatch={
                        (subAction: PasswordChangeAction) =>
                            dispatch({
                                type: 'PasswordChangePageAction',
                                subAction,
                            })}
                />)
        case 'InquiryOverviewPage':
            return (
                <InquiryOverviewView
                    state={page.state}
                    dispatch={
                        (subAction: InquiryOverviewAction) =>
                            dispatch({
                                type: 'InquiryOverviewPageAction',
                                subAction,
                            })}
                />)
        case 'InquiryDetailsPage':
            return (
                <InquiryDetailsView
                    state={page.state}
                    dispatch={
                        (subAction: InquiryDetailsAction) =>
                            dispatch({
                                type: 'InquiryDetailsPageAction',
                                subAction,
                            })}
                />
            )
        case 'ProductCalculationOverviewPage':
            return (
                <ProductCalculationOverviewView
                    state={page.state}
                    dispatch={
                        (subAction: ProductCalculationOverviewAction) =>
                            dispatch({
                                type: 'ProductCalculationOverviewPageAction',
                                subAction,
                            })
                    }
                />
            )
        case 'ProductCalculationDetailsPage':
            return (
                <ProductCalculationDetailsView
                    state={page.state}
                    dispatch={
                        (subAction: ProductCalculationDetailsAction) =>
                            dispatch({
                                type: 'ProductCalculationDetailsPageAction',
                                subAction,
                            })
                    }
                />
            )
        case 'ProductCalculationImportPage':
            return (
                <ProductCalculationImportView
                    state={page.state}
                    dispatch={
                        (subAction: ProductCalculationImportAction) =>
                            dispatch({
                                type: 'ProductCalculationImportPageAction',
                                subAction,
                            })
                    }
                />
            )
        case 'PrismaRequestOverviewPage':
            return (
                <PrismaRequestOverviewView
                    state={page.state}
                    dispatch={
                        (subAction: PrismaRequestOverviewAction) =>
                            dispatch({
                                type: 'PrismaRequestOverviewPageAction',
                                subAction,
                            })
                    }
                />
            )
        case 'PrismaRequestDetailsPage':
            return (
                <PrismaRequestDetailsView
                    state={page.state}
                    dispatch={
                        (subAction: PrismaRequestDetailsAction) =>
                            dispatch({
                                type: 'PrismaRequestDetailsPageAction',
                                subAction,
                            })
                    }
                />
            )
        case 'AuthenticatedRedirectPage':
            return <p>Redirecting...</p>
        case 'AuthenticatedNotFoundPage':
            return <p>Seite nicht gefunden.</p>
    }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/App/View.tsx